export const locale = {
    lang: 'fr',
    data: {
        'YOUR_SESSION_EXPIRES_IN':'Votre session expire dans :'
    }
};